import { render, staticRenderFns } from "./DealImageCard.vue?vue&type=template&id=626cbb9e&"
import script from "./DealImageCard.vue?vue&type=script&lang=ts&"
export * from "./DealImageCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports